export default "__VITE_ASSET__AB0QBsrg__"